export default [
  {
    path: "/termos-filtros",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "termos_filtros_list",
        path: "",
        component: () => import("./pages/List.vue"),
        meta: {
          permission: "traducoes:view",
          title: "Termos de filtros",
        },
      },
      {
        name: "termos_filtros_edit",
        path: ":tipo/:id",
        component: () => import("./pages/Edit.vue"),
        meta: {
          permission: "traducoes:view",
          title: "Traduções do termo",
          breadcrumbs: [
            { label: "Termos de filtros", to: "termos_filtros_list" },
          ],
        },
      },
    ],
  },
];
